import { Theme } from "@mui/material";

export const getCardStyles = (theme: Theme) => ({
  boxShadow: theme.customShadows.card,
  border: "none",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  borderRadius: "20px",
  padding: 2,
  paddingX: 2,
  gap: { xs: 2, md: 5 },
});

export const imageContainerStyles = {
  width: { xs: "100%", md: "auto" },
  height: { xs: 241, sm: 353 },
  mx: "auto",
  overflow: "hidden",
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  img: { width: "100%", height: "100%", objectFit: "contain" },
};

export const imageStyles = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};
